import { BaseNode } from "./baseNode";

export const ImageNode = ({ id }) => {
  return (
    <BaseNode
      id={id}
      title="Image"
      leftHandles={[
        { id: `${id}-input`, top: '50%', label: 'Image' }
      ]}
      rightHandles={[
        { id: `${id}-output`, top: '50%', label: 'Processed' }
      ]}
    >
      <div>Image Processing</div>
    </BaseNode>
  );
};
